export type translation = {
    id?: string;
    name: string;
    description?: string;
    lang: string;
    defaultLang: boolean;
}

export class TranslationDTO {
    id?: string
    name: string
    description?: string
    lang: string
    defaultLang: boolean

    static convinienceConstructor(arg: translation) {
        const { id, name, description, lang, defaultLang } = arg;
        return new TranslationDTO(name, lang, defaultLang, id, description,)
    }

    constructor(
        name = "",
        lang = "ko",
        defaultLang = true,
        id?: string,
        description?: string
    ) {
        this.id = id
        this.name = name
        this.description = description
        this.lang = lang
        this.defaultLang = defaultLang
    }
}